<div *ngIf="carousel?.length" class="carousel">
    <app-image-preload [ngClass]="{'carousel-element': true, 'active': !active}"
                       [normal]="carousel[0]?.image?.image" [retina]="carousel[0]?.image?.retinaImage"
                       [endpoint]="'RESOURCES'" (loadComplete)="imageLoaded(0)"></app-image-preload>
    <app-image-preload *ngIf="carousel?.length > 1" [ngClass]="{'carousel-element': true, 'active': active}"
                       [normal]="carousel[1]?.image?.image" [retina]="carousel[1]?.image?.retinaImage"
                       [endpoint]="'RESOURCES'" (loadComplete)="imageLoaded(1)"></app-image-preload>
</div>